
import { Grid, Paper, Typography } from "@material-ui/core";
import Authorize from "components/Authorize";
import { permissionProfiles } from "components/Authorize/permissionProfiles";
import LoadingSpinner from 'components/LoadingSpinner';
import { activityColors, activityStatusById, activityStatuses } from "features/activity/activityConsts";
import { useGetAllActivityItemsQuery } from "features/activity/activitySlice";
import { FlagEntityTypes } from "features/flag/flagsConsts";
import { FlagAsset } from "features/vehicles/Flags/FlagAsset";
import FormatService from "services/formatService";
import { arrayToObject } from "utils/object-util";
import WorkOrderActions from "../../../WorkorderDashboard/WorkOrderCard/WorkOrderActions";
import { workorderApprovalStyle } from "../style";
import { loadStatuses, loadStatusesById } from "features/loads/enums";

const WorkOrderCard = ({ entity, isLoadingData, handleDone, showActions = true }) => {
    const classes = workorderApprovalStyle();
    const loadMode = !entity?.workOrderId;

    let { data: activityItems, error: activityItemsError, isLoading: isLoadingActivityItems } = useGetAllActivityItemsQuery();

    const activityItemsLookup = arrayToObject(activityItems);

    const activityType = activityItemsLookup?.[entity?.activityItemId];
    const status = entity?.activityId ?? entity?.latestStatus;
    const stillPending = status == activityStatuses.PendingClientApproval
        || status == loadStatuses.PENDING_PRICING_APPROVAL
        || status == loadStatuses.PENDING_CLIENT_APPROVAL;

    const isLoading = () => {
        return isLoadingData || isLoadingActivityItems;
    }

    return (
        <>
            <div className={classes.divWrap}>
                <LoadingSpinner loading={isLoading()} />
                {entity && <Paper className={classes.card} style={{ borderStyle: 'solid', borderColor: `${activityColors[status]}`, borderWidth: '0 0 0 7px' }}>
                    <Grid container direction="row" alignItems="center" justifyContent="space-between" spacing={2} className={classes.container}>

                        <Grid item xs={8} className={classes.textWrapper} alignContent="center">
                            <div className={classes.wrapper}>
                                <Typography className={classes.lightText}>
                                    {entity?.clientName}
                                </Typography>

                                {stillPending && <Typography className={classes.lightText}>
                                    {loadMode ? FormatService.formatDateNoConversion(entity?.latestStatusDate) : FormatService.formatDateNoConversion(entity?.activityDateFormatted)}
                                </Typography>}
                            </div>

                            <Grid container className={classes.textWrapper}>
                                <Grid item xs={7} >
                                    <Typography className={classes.regText}>
                                        {loadMode ? 'Load Pricing' : 'Type of activity'}
                                    </Typography>
                                    <Typography className={classes.boldText}>
                                        {loadMode ? `VRID: ${entity?.id || '-'}` : activityType?.name ?? 'Unknown'}
                                    </Typography>
                                    {
                                        entity?.assets?.length > 1 ?
                                            <Grid style={{ maxHeight: '50px', overflowY: 'auto' }}>
                                                <Typography className={classes.regText}>
                                                    Asset IDs:{entity?.assets?.map(asset => ` ${asset?.externalId || asset?.assetId || '-'}`).join(', ')}
                                                </Typography>
                                                <Typography className={classes.regText} >
                                                    {entity?.assets?.map(asset => asset?.vin).join(', ')}
                                                </Typography>
                                            </Grid>
                                            :
                                            <>
                                                <Typography className={classes.regText}>
                                                    {`Asset ID: ${entity?.externalId || entity?.assetId || '-'}`}
                                                </Typography>
                                                <Typography className={classes.regText}>
                                                    {`${entity?.descriptor ?? entity?.vinsForSearch}`}
                                                </Typography>
                                            </>

                                    }

                                </Grid>
                                <Grid item xs={5} >
                                    <Typography className={classes.regText}>
                                        <div className={classes.indicatorWrapper}>
                                            <div item xs={2}>
                                                <div className={classes.indicator} style={{ background: loadMode ? '#FCC354' : activityColors[status] }}></div>
                                            </div>
                                            {loadMode ? loadStatusesById?.[status]?.name : activityStatusById?.[status]?.name}
                                        </div>
                                    </Typography>
                                    <Authorize profile={permissionProfiles.ACTIVITY.ACTIVITY_EDIT}>
                                        <Typography className={classes.boldText}>
                                            Cost: ${loadMode ? entity?.loadPrice?.cost : entity?.price}
                                        </Typography>
                                    </Authorize>
                                    <Typography className={classes.regText}>
                                        Price: ${loadMode ? entity?.loadPrice?.charge : entity?.revenue}
                                    </Typography>
                                </Grid>
                            </Grid>

                        </Grid>
                        {showActions ? <WorkOrderActions entity={loadMode ? { ...entity?.loadPrice, groupId: entity?.groupId } : entity} handleDone={handleDone} stillPending={stillPending} fill={false} loadMode={loadMode} />
                            : <Grid item xs={4} className={classes.actionWrapper}>
                                <FlagAsset
                                    selectedRows={[entity.id]}
                                    allData={[{ ...entity }]}
                                    entityType={FlagEntityTypes.ACTIVITY}
                                    readonly
                                    getFlagFromApi={false}
                                    flagObj={entity.latestFlag}
                                    flagOn={entity?.latestFlag}
                                />
                            </Grid>
                        }
                    </Grid>
                </Paper>}
            </div>
        </>
    )
}

export default WorkOrderCard;